import i18n from '../i18n'

export default {
  install (Vue) {
    // var lang = localStorage.getItem('g2e-lang')
    // var lang = i18n.locale

    // if (!lang) {
    //   lang = localStorage.getItem('g2e-lang')
    // }

    // if (!lang) {
    //   lang = 'zh'
    // }

    // key-word: chin or port
    // if lang === zh, port will replace to chin
    // example: if (lang === zh) and (fieldName === abcPortName), it will retun abcChinName
    Vue.prototype.$chPtField = function (fieldName) {
      let tFieldName
      if (i18n.locale === 'zh') {
        tFieldName = fieldName.replace('port', 'chin')
        tFieldName = tFieldName.replace('Port', 'Chin')
      } else {
        tFieldName = fieldName.replace('chin', 'port')
        tFieldName = tFieldName.replace('Chin', 'Port')
      }

      return tFieldName
    }

    // key-word: chin or port
    // if lang === zh, port will replace to chin, and get the field data from obj
    // example: if (lang === zh) and (fieldName === abcPortName), it will retun abcChinName
    Vue.prototype.$chPtObjData = function (fieldName, obj) {
      let tFieldName
      if (i18n.locale === 'zh') {
        tFieldName = fieldName.replace('port', 'chin')
        tFieldName = tFieldName.replace('Port', 'Chin')
        if (!obj[tFieldName]) {
          tFieldName = fieldName.replace('chin', 'port')
          tFieldName = tFieldName.replace('Chin', 'Port')
        }
      } else {
        tFieldName = fieldName.replace('chin', 'port')
        tFieldName = tFieldName.replace('Chin', 'Port')
        if (!obj[tFieldName]) {
          tFieldName = fieldName.replace('port', 'chin')
          tFieldName = tFieldName.replace('Port', 'Chin')
        }
      }

      if (obj[tFieldName]) {
        return obj[tFieldName]
      } else {
        return ''
      }
    }

    Vue.prototype.$numberToMonth = function (number) {
      const chin = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      const port = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      if (i18n.locale === 'zh') {
        return chin[number]
      } else {
        return port[number]
      }
    }
  }
}
